import { PlayerConfig } from "./consts";
import { PlayerInputController } from "@controllers/input";
import { setDead, setRunning } from "@stores";
import Entity from "../../Entity";
import { Skorpion, Uzi } from "../../guns";
import AssetLoader from "@managers/loaders";
import PlayerFiniteStateMachine from "./fsm";
import PlayerAnimationController from "./animations";
import { GunController } from "@controllers/guns";
import { ModelMeshController } from "@controllers/mesh";
class Player extends Entity {
    static instance;
    /**
     * Player object.
     * @param scene the rendering scene.
     * @param physicsWorld the physics world.
     * @private
     */
    constructor(scene, physicsWorld) {
        const assetLoader = AssetLoader.getInstance();
        const meshController = new ModelMeshController(assetLoader.getPlayerAssets.modelLoader, PlayerConfig.RECEIVE_SHADOW, PlayerConfig.CAST_SHADOW);
        const gunController = new GunController(new Skorpion(assetLoader), new Uzi(assetLoader));
        const inputController = PlayerInputController.getInstance(gunController);
        const animationController = new PlayerAnimationController(assetLoader, meshController.getMesh);
        const finiteStateMachine = new PlayerFiniteStateMachine(animationController);
        super(PlayerConfig, scene, physicsWorld, meshController, inputController, finiteStateMachine, gunController);
    }
    kill() {
        setDead(true);
        setRunning(false);
    }
    get getInputController() {
        return this.characterController.getInputController;
    }
    static getInstance(scene, physicsWorld) {
        if (!Player.instance)
            Player.instance = new Player(scene, physicsWorld);
        return Player.instance;
    }
}
export { Player };
